export default __webpack_public_path__ + "static/media/add-your-own.21ca17ad.jpg";